/** Outcome of waiting for a Celery task (see useTaskCompletion). Pure module. */
export interface TaskCompletionResult {
  status: 'SUCCESS' | 'FAILURE';
  result?: any;
  error?: string;
  /** Stable job error code from the server (`provider_unavailable`, ...); localize via jobs.errors.<code>. */
  errorCode?: string;
}

/** A FAILURE outcome from a task_error event or a status poll (error text plus its code, when sent). */
export function taskFailureOutcome(error?: string | null, errorCode?: string | null): TaskCompletionResult {
  return {
    status: 'FAILURE',
    error: error || 'Task failed',
    ...(errorCode ? { errorCode } : {}),
  };
}

/** SUCCESS -> result (or null); FAILURE -> throws with the task error (and `.code` when coded). */
export function unwrapTaskOutcome<T = unknown>(outcome: TaskCompletionResult): T | null {
  if (outcome.status === 'FAILURE') {
    const error = new Error(outcome.error || 'Task failed') as Error & { code?: string };
    if (outcome.errorCode) error.code = outcome.errorCode;
    throw error;
  }
  return (outcome.result as T | undefined) ?? null;
}
